import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Book } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png'
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/menu', label: 'Menu' },
    { path: '/banquets', label: 'Banquets & Catering' },
    { path: '/about', label: 'About Us' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <motion.header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-28">
          {/* Logo */}
          <motion.div 
            className="flex items-center cursor-pointer"
            onClick={() => handleNavigation('/')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            
           
            <img 
  src={logo} 
  alt="Logo"
 className="w-40 sm:w-48 lg:w-56 h-auto object-contain"
/>
           
          </motion.div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navItems.map((item) => (
              <motion.button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={`text-base font-medium transition-all duration-300 hover:text-amber-600 relative ${
                  location.pathname === item.path
                    ? 'text-amber-600'
                    : isScrolled
                    ? 'text-gray-700'
                    : 'text-amber-600'
                }`}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {item.label}
                {location.pathname === item.path && (
                  <motion.div
                    className="absolute -bottom-1 left-0 right-0 h-0.5 bg-amber-600"
                    layoutId="underline"
                  />
                )}
              </motion.button>
            ))}
            <Button
              onClick={() => handleNavigation('/reservations')}
              className="bg-amber-700 hover:bg-amber-800 text-white px-6 py-2 rounded-lg transition-all duration-300 hover:scale-105"
            >
              <Phone className="w-4 h-4 mr-2" />
              Reserve Now
            </Button>

             <Button
  onClick={() => window.open('/menu-card.pdf', '_blank')}
  className="bg-amber-700 hover:bg-amber-800 text-white py-3 rounded-lg transition-all duration-300"
>
  <Book className="w-4 h-4 mr-2" />
  Our Menu Card
</Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors duration-300 ${
              isScrolled ? 'text-gray-700' : 'text-gray-700'
            }`}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <motion.div
            className="lg:hidden py-4 bg-white/95 backdrop-blur-md rounded-lg mt-2 shadow-xl"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <nav className="flex flex-col space-y-4 px-4">
              {navItems.map((item) => (
                <button
                  key={item.path}
                  onClick={() => handleNavigation(item.path)}
                  className={`text-left font-medium hover:text-amber-600 transition-colors duration-300 py-2 ${
                    location.pathname === item.path ? 'text-amber-600' : 'text-gray-700'
                  }`}
                >
                  {item.label}
                </button>
              ))}
<Button
  onClick={() => window.open('/menu-card.pdf', '_blank')}
  className="bg-amber-700 hover:bg-amber-800 text-white py-3 rounded-lg transition-all duration-300"
>
  <Book className="w-4 h-4 mr-2" />
  Our Menu Card
</Button>
              <Button
                onClick={() => handleNavigation('/reservations')}
                className="bg-amber-700 hover:bg-amber-800 text-white w-full py-3 rounded-lg transition-all duration-300"
              >
                <Phone className="w-4 h-4 mr-2" />
                Reserve Now
              </Button>
             
            </nav>
          </motion.div>
        )}
      </div>
    </motion.header>
  );
};
